import { render } from "./Title.vue?vue&type=template&id=5221967c&bindings={\"title\":\"props\",\"preheader\":\"props\",\"labelLeft\":\"props\",\"labelRight\":\"props\",\"shape\":\"props\",\"subtitle\":\"props\",\"subtitleDate\":\"props\",\"shapeSvg\":\"options\"}"
import script from "./Title.vue?vue&type=script&lang=js"
export * from "./Title.vue?vue&type=script&lang=js"

import "./Title.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script